<sl-radio-group
    ngDefaultControl
    [formlyAttributes]="field"
    [value]="formControl.value"
    [label]="props.label | htmlDecode"
    [required]="props.required || false"
    [shoelaceReadonly]="props.readonly"
    (sl-change)="onValueChange($event)">
    <ng-container *ngFor="let option of getOptions() let i = index">
        <sl-radio class="radio" [id]="id + '_' + i" [value]="option.value" [shoelaceReadonly]="props.readonly">
            {{option.label}}
        </sl-radio>
    </ng-container>
</sl-radio-group>